// date-range.store.ts
import { Injectable, signal } from '@angular/core';
import { DateHelper } from '../shared/util/date-helper';
export type DateRange = [Date, Date];

@Injectable({ providedIn: 'root' })
export class DateRangeStore {
  public readonly range = signal<DateRange>([DateHelper.oneWeekBeforeNow(), DateHelper.oneWeekAfterNow()]);
}
